module.exports = __webpack_public_path__ + "img/account_bg_top.7f90f30b.png";